import { useTranslation } from "react-i18next";

interface SpellStatsComponentProps{
    // creatureStats: CreatureStats,
    // updateCreatureStats: (creatureStats: CreatureStats) => void,
    editMode: boolean,
    // expanded: boolean,
    spellCharacteristic: string,
    spellSave: number,
    spellAttackMod: number,
    updateStats: (spellCharacteristic: string,spellSave: number,spellAttackMod: number) => void
}

const SpellStatsComponent = (props: SpellStatsComponentProps)=> {
    const { t } = useTranslation();

    return(
        <>
        <div className="stat-row-horiz">
            <span className="col-3">{t("spell-char")}</span>
            {props.editMode ? 
                <input
                    value={props.spellCharacteristic ?? ""}
                    className="w-75 form-control"
                    placeholder={t("spell-char")}
                    type="text"
                    onChange={e => {
                        props.updateStats(e.target.value, props.spellSave, props.spellAttackMod);
                        // props.updateSpellcastingStats(props.spellcastingStats);
                    }}
                ></input>
            :
            <span>{props.spellCharacteristic ?? ""}</span>
            }
        </div>
        <div className="stat-row-horiz">
            <span className="col-3">{t("spell-save")}</span>
            {
                props.editMode ? 
                    <input
                        value={props.spellSave ?? 0}
                        type="text"
                        className="w-75 form-control"
                        onChange={e => {
                            props.updateStats (props.spellCharacteristic, parseInt(e.target.value), props.spellAttackMod);
                            // props.updateSpellcastingStats(props.spellcastingStats);
                        }}
                    ></input>
                :
                <span>{props.spellSave ?? 0}</span>
            }
        </div>
        <div className="stat-row-horiz">
            <span className="col-3">{t("spell-attackmod")}</span>
            {
                props.editMode ? 
                    <input
                        value={props.spellAttackMod ?? 0}
                        className="form-control w-75"
                        type="text"
                        onChange={e => {
                            props.updateStats (props.spellCharacteristic, props.spellSave, parseInt(e.target.value));
                            // props.updateSpellcastingStats(props.spellcastingStats);
                        }}
                    ></input>
                :
                <span>{props.spellAttackMod ?? 0}</span>
            }
        </div>
        </>
    )
}
export default SpellStatsComponent;